import React, { useState } from "react";
import ClickOutside from "./clickOutside";

const CheckboxDropdown = ({
  list = [],
  width = "w-full",
  text,
  toggleParent,
  toggleChild,
  selectedDamage
}) => {
  const [open, setOpen] = useState(false);

  const isParentChecked = (parent) =>
    parent.children.every((child) => selectedDamage[child.value]);

  // display selectedDamage count in header
  const selectedCount = Object.values(selectedDamage).filter(Boolean).length;

  return (
    <ClickOutside isOpen={open} onClickOutside={() => setOpen(false)}>
      <div className="relative">
        {/* Header */}
        <div
          onClick={() => setOpen(!open)}
          className={`flex items-center justify-between gap-2 rounded-lg border border-grey-10 p-3 ${width} h-10 cursor-pointer bg-white`}
        >
          <span className="font-InterRegular text-ft14-17 text-grey-120">
            {text} :
          </span>

          <div className="flex items-center gap-2">
            <span className="font-InterMedium text-ft14-17 text-black-10">
              {selectedCount > 0 ? `${selectedCount} Selected` : "None"}
            </span>
            <img src="/images/down-icon.svg" alt="" />
          </div>
        </div>

        {/* Dropdown Panel */}
        {open && (
          <div className="absolute z-30 flex max-h-40 w-full flex-col overflow-y-auto rounded-lg border border-grey-10 bg-white p-2">
            {list.map((parent, i) => (
              <div key={i}>
                {/* PARENT */}
                <label className="flex cursor-pointer items-center gap-2 rounded p-2 hover:bg-grey-40">
                  <input
                    type="checkbox"
                    className="size-4"
                    checked={isParentChecked(parent)}
                    onChange={() => toggleParent(parent)}
                  />
                  <span className="font-InterMedium text-black-10">
                    {parent.label}
                  </span>
                </label>

                {/* CHILDREN */}
                <div className="flex flex-col pl-7">
                  {parent.children.map((child, j) => (
                    <label
                      key={j}
                      className="flex cursor-pointer items-center gap-2 rounded px-2 py-1 hover:bg-grey-40"
                    >
                      <input
                        type="checkbox"
                        className="size-4"
                        checked={!!selectedDamage[child.value]}
                        onChange={() => toggleChild(child)}
                      />
                      <span className="font-InterRegular text-black-10">
                        {child.label}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </ClickOutside>
  );
};

export default CheckboxDropdown;
